import { Navigate } from "react-router-dom";

export default function RegPage() {
  return <Navigate to="/login?tab=register" replace />;
}
